<template>
  <div
    :class="['wptv-hover-dropdown', {'force-visible': focus}]"
    @click="onClick">
    <div
      ref="panel"
      class="panel">
      <div
        class="title"
        tabindex="0"
        @blur="onBlur">
        <slot name="title" />
        <div
          class="icon help-arrow-down"
          data-wptv="drop-panel-arrow" />
      </div>
      <div
        :class="['drop-panel', { 'drop-panel-left' : dropdownAlign === 'left'}]">
        <span class="drop-panel-caret" />
        <slot
          name="panel"
          @click="focus = false" />
      </div>
    </div>
  </div>
</template>

<script>
const sides = ['left', 'right']

export default {
  name: 'WptvHoverDropdown',
  props: {
    dropdownAlign: {
      default: 'left',
      type: String,
      validator: value => sides.includes(value)
    }
  },

  data () {
    return {
      focus: false
    }
  },
  mounted () {
    document.body.addEventListener('touchstart', this.handleClickOutside)
  },
  beforeDestroy () {
    document.body.removeEventListener('touchstart', this.handleClickOutside)
  },
  methods: {
    onBlur (evt) {
      var relatedTarget = evt.relatedTarget || // chrome & others
          evt.explicitOriginalTarget || // mozilla
          document.activeElement // IE11
      setTimeout(() => {
        const isInside = relatedTarget && this.$refs.panel.contains(relatedTarget)
        this.focus = this.focus === true && isInside
      }, 300)
    },
    onClick () {
      this.focus = !this.focus
    },
    handleClickOutside (evt) {
      if (this.$refs.panel) this.focus = this.$refs.panel.contains(evt.target)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../../scss/abstracts/variables';

.wptv-hover-dropdown {
  .panel {
    position: relative;
    height: 100%;
    width: 100%;

    &:focus {
      color: #ff0;
    }

    .title {
      display: inline-block;

      >div {
        display: inline-block;
      }
    }

    .drop-panel {
      position: absolute;
      display: block;
      visibility: hidden;
      font-size: 1rem;
      top: 30px;
      right: 0;
      width: auto;
      background: $white;
      border: 1px solid $lightgrey;
      white-space: nowrap;

      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;

        li {
          color: $black;
          margin: 0;
          position: relative;

          a {
            display: block;
            padding: 0.5em;

            &:hover {
              color: $black;
            }
          }

          &:not(:first-child) {
            border-top: 1px solid $lightgrey;
          }

          &:hover {
            background-color: #ddd;
          }
        }
      }

      .drop-panel-caret {
        position: absolute;
        top: -7px;
        left: 80%;
        width: 13px;
        height: 13px;
        transform: translateX(-9px) rotate(45deg) scale(1, 1);
        background: $white;
        border: 1px solid $lightgrey;
        border-width: 1px 0 0 1px;
      }

      &.drop-panel-left {
        right: auto;
        left: 0;

        .drop-panel-caret {
          left: 20%;
        }
      }
    }
  }

  &.force-visible {
    .drop-panel {
      visibility: visible;
    }

    .drop-panel-caret {
      visibility: visible;
    }

    .help-arrow-down {
      transform: rotate(180deg);
      transition: transform 0.4s ease-in-out;
    }
  }

  .help-arrow-down {
    position: relative;
    top: -3px;
    display: inline-block;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #000;
    transition: transform 0.4s ease-in-out;
  }
}
</style>
